export const QUEUED = 'queued'
export const EXECUTING = 'executing'
export const FINISHED = 'finished'
export const FAILED = 'failed'
export const CANCELED = 'canceled'
